import app from './app.json';
import common from './common.json';
import page from './page.json';
const mkMK = {
    app,
    common,
    page
};
export default mkMK;
